<template>
  <div>
    <div class="content" style="width:auto;overflow-x: hidden;">
      <div class="cont-list">
        <span class="list"> 无形资产-{{ title }}{{ typeName }}资产信息 </span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules" autocomplete="off">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">资产基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="资产编号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成资产编号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="name">
                <el-input :disabled="!editMode" v-model="form.name" placeholder="请填写资产名称" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input :disabled="!editMode" v-model="form.specName" placeholder="请填写规格型号" style="width:90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产单位" prop="unitName">
                <el-select :disabled="!editMode" v-model="form.unitName" style="width: 90%" filterable placeholder="请填写资产单位" :filter-method="getUnits" @change="unitChange">
                  <el-option v-for="item in STATIC_Units" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产品牌" prop="brandName">
                <el-select :disabled="!editMode" v-model="form.brandName" style="width: 90%" filterable placeholder="请选择品牌" :filter-method="getBrands" @change="brandChange" clearable>
                  <el-option v-for="item in STATIC_Brands" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <el-select :disabled="!editMode" v-model="form.manufacturerName" placeholder="请选择生产厂家" style="width: 90%;" clearable :filter-method="getManufacturers" @change="manufacturerChange">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商" prop="supplierName">
                <el-select :disabled="!editMode" v-model="form.supplierName" placeholder="请选择供应商" style="width: 90%;" clearable :filter-method="getSuppliers" @change="supplierChange">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlace">
                <el-select :disabled="!editMode" v-model="form.productionPlace" placeholder="请选择产地类型" style="width: 90%;">
                  <el-option v-for="item in ProductionPlaceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="注册证号" prop="certNo">
                <el-select :disabled="!editMode" v-model="form.certNo" placeholder="请选择注册证号" style="width: 90%;" :filter-method="getRegistCerts" @change="certChange" clearable>
                  <el-option v-for="item in STATIC_ManufacturerProductRegistCerts" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产类型" prop="assetType">
                <SelectTree :disabled="!editMode" @handleCheckChange="handleCheckChange" :filterable="true" :filterMethod="getAssetTrees" :defaultProps="defaultProps" :placeholder="'请选择资产类型'" :data="STATIC_FixedAssetTrees" :defaultValue="form.assetTypeName" style="width: 90%;" clearable></SelectTree>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="财务分类" prop="financeType">
                <SelectTree :disabled="!editMode" @handleCheckChange="financeTypeChange" :filterable="true" clearable :filterMethod="getFinanceTypes" :defaultProps="defaultProps" :placeholder="'请选择财务分类'" :data="STATIC_FinanceTypes" :defaultValue="form.financeTypeName" style="width: 90%;"></SelectTree>
                <!-- <el-select :disabled="!editMode" v-model="form.financeTypeName" placeholder="请选择财务分类" style="width: 90%;" :filter-method="getFinanceTypes" @change="financeTypeChange" clearable>
                  <el-option v-for="item in STATIC_FinanceTypes" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="关联合同" prop="contractNo">
                <el-select :disabled="!editMode" v-model="form.contractNo" style="width: 90%" filterable placeholder="请选择关联合同" :filter-method="getContracts" @change="contractChange" clearable>
                  <el-option v-for="item in STATIC_Contracts" :key="item.id" :label="item.contractNo" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品来源" prop="productSourceName">
                <el-select :disabled="!editMode" v-model="form.productSourceName" style="width: 90%" filterable placeholder="请选择产品来源" :filter-method="getProductSource" @change="productSourceChange" clearable>
                  <el-option v-for="item in STATIC_ProductSource" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <el-input-number :disabled="!editMode" v-model="form.price" :min="0" :precision="4" :controls="false" placeholder="请填写单价" style="width: 90%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否效益资产" prop="isBenefit">
                <el-select :disabled="!editMode" v-model="form.isBenefit" placeholder="请选择状态" style="width: 90%;">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width:90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="更新时间" prop="updateTime">
                <el-date-picker v-model="form.updateTime" disabled type="datetime" placeholder="系统自动带出更新时间" style="width:90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 资金来源 -->
          <el-row>
            <template v-for="(item, index) in form.capitalSourceDetails">
              <div :key="index">
                <el-col :span="6">
                  <el-form-item prop="capitalSourceName">
                    <label slot="label">
                      <span>{{
                        "资金来源(" +
                          Arabia_To_SimplifiedChinese(index + 1) +
                          ")"
                      }}</span>
                      <span v-if="editMode" style="margin-left:20px;" class="color-blue pointer" type="text" v-preventReClick @click="removeCapitalSource(item)">删除</span>
                    </label>

                    <el-select :disabled="!editMode" v-model="item.capitalSourceName" placeholder="请选择资金来源" style="width: 90%;" filterable :filter-method="getCapitalSources" @change="csChange(item)" clearable>
                      <el-option v-for="item in STATIC_CapitalSources" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="比例/金额">
                    <SeparateInput :disabled="!editMode" :left="item.ratio" :right="item.amount" :maxRight="form.price ? form.price : 0" @change="(left, right) => ratioChange(item, left, right)" style="width: 90%;"></SeparateInput>
                  </el-form-item>
                </el-col>
              </div>
            </template>
          </el-row>
          <div v-if="editMode" style="cursor: pointer;margin-left:10px; width: 96px;" v-preventReClick @click="addCapitalSource">
            <img src="@/assets/icons/plus-blue.png" alt="" class="addbtn" />
            <span style="font-size:13px;color: #286AB4;margin-left:5px">添加资金来源</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:95%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="" label-width="0" prop="fileInfos">
              </el-form-item>
              <UploadFileList :fileList="form.fileInfos" btnShowType="always" :editMode="editMode" @fileChange="fileChange"></UploadFileList>
            </el-col>
          </el-row>
          <el-row style="margin-top:20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top:10px;padding-bottom:10px">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">证件信息</span>
          </div>

          <template v-for="(item, index) in form.details">
            <el-row :key="index">
              <el-col :span="6">
                <el-form-item>
                  <label slot="label">
                    <span>{{
                      "证件类型(" + Arabia_To_SimplifiedChinese(index + 1) + ")"
                    }}</span>
                    <span v-if="editMode" style="margin-left:20px;" class="color-blue pointer" type="text" v-preventReClick @click="removeDetail(item)">删除</span>
                  </label>
                  <el-select :disabled="!editMode" v-model="item.category" placeholder="请选择证件类型" style="width: 100%;" filterable clearable :filter-method="GetNoneCertCategorys">
                    <el-option v-for="item in STATIC_NoneCertCategorys" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <!-- <el-select
                    :disabled="!editMode"
                    v-model="item.category"
                    style="width: 100%"
                    filterable
                    clearable
                    placeholder="请选择证件类型"
                  >
                    <el-option
                      v-for="item in ManufacturerCertificateOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="证件编码" :prop="'details.' + index + '.no'" :rules="certificateRules.no">
                  <el-input :disabled="!editMode" placeholder="请填写证件编码" v-model="item.no"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="证件名称" :prop="'details.' + index + '.certificateName'" :rules="certificateRules.certificateName">
                  <el-input :disabled="!editMode" placeholder="请填写证件名称" v-model="item.certificateName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="证件生效日期" :prop="'details.' + index + '.startDate'" :rules="certificateRules.startDate">
                  <el-date-picker :disabled="!editMode" v-model="item.startDate" style="width: 100%" type="date" @change="dateChange(item, 0)" value-format="yyyy-MM-dd" placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="证件失效日期" :prop="'details.' + index + '.endDate'" :rules="certificateRules.endDate">
                  <el-date-picker :disabled="!editMode" v-model="item.endDate" style="width: 100%" type="date" @change="dateChange(item, 1)" value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="{
                      disabledDate(v) {
                        return disabledDateFun(v, item);
                      },
                    }">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 还不太清楚这个datepicker为什么会触发谷歌浏览器的密码填充，但是在它后面加一个input就不会触发，暂时先这样处理 -->
              <el-input style="position: absolute;z-index: -999"></el-input>
              <el-col :span="6">
                <el-button v-show="editMode" class="btn default" size="small" style="margin-left:5px;width:60px;margin-top:30px;" v-preventReClick @click="changeEndDate(item)">
                  永久
                </el-button>
              </el-col>
              <el-col :span="24" style="display: flex;">
                <UploadFileList label="上传证书" :fileList="item.fileInfos ? [item.fileInfos[0]] : []" btnShowType="always" :multipleFile="false" :showFileList="false" :editMode="editMode" @fileChange="detailsFileChange($event, item)"></UploadFileList>
                <div class="certificateState">
                  证书状态：<span>{{ item.stateName }}</span>
                </div>
              </el-col>
            </el-row>
          </template>
          <div v-if="editMode" style="cursor: pointer;margin-left:10px; width: 96px;" v-preventReClick @click="addDetail">
            <img src="@/assets/icons/plus-blue.png" alt="" class="addbtn" />
            <span style="font-size:13px;color: #286AB4;margin-left:5px">添加证件信息</span>
          </div>
        </div>

        <InvoiceEdit></InvoiceEdit>

        <div class="edit-card" style="margin-top:10px;padding-bottom:10px">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">邀请评估</span>
          </div>
          <el-row>
            <el-col :span="12">
              <el-form-item label="邀请成员" prop="userIds" style="width:95%">
                <div class="select_multiple_value2" v-preventReClick @click="showSelectUserDialog">
                  <template v-if="form.userInfos && form.userInfos.length > 0">
                    <template v-for="item in form.userInfos">
                      <div :key="item.id" class="value">
                        <span>{{ item.no + " " + item.name + " " }}
                          <i v-if="editMode" class="el-icon-close" v-preventReClick @click="removeUserItem(item, $event)" />
                        </span>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <span class="placeholder">请选择相关成员</span>
                  </template>
                </div>
                <select-user :show="showSelectUser && editMode" :oldData="form.userInfos" @getData="getSelectUserData" @close="closeSelectUser"></select-user>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>

        <!-- 密码资产状态 -->
        <el-row>
          <el-col :span="6">
            <el-form-item label="密码启用状态" style="margin-top:20px;">
              <el-switch :disabled="!editMode" v-model="form.passWordState" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
              </el-switch>
              <span v-if="form.passWordState">启用</span>
              <span v-else>禁用</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="" :prop="form.passWordState ? 'passWord' : ''">
              <el-input placeholder="请填写密码" v-model="form.passWord" autocomplete="off" type="text" :disabled="form.passWordState == 0" style="width:90%;text-security:disc; -webkit-text-security:disc;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <span class="psw-desc">
              该密码仅用于查看当前资产详情及附件、证书等资料，保存后仅当前操作人员/超级管理员可以编辑此资产信息
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="资产启用状态">
              <el-switch :disabled="!editMode" v-model="form.state" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
              </el-switch>
              <span v-if="form.state">启用</span>
              <span v-else>禁用</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import GetDataMixin from "@/mixin/getData-mixin.js";
import { Arabia_To_SimplifiedChinese } from "@/utils/number.js";
import { GetNoneAssetById, RejectNoneAsset, SaveNoneAsset } from "@/api";
import {
  WarehouseOutStockOptions,
  ProductionPlaceOptions,
  WhetherOptions,
  ManufacturerCertificateOptions,
} from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import SelectTree from "@/components/select-tree";
import UploadFileList from "@/components/upload-file-list";
import SeparateInput from "@/components/separate-input";
import InvoiceEdit from "@/components/invoice-edit";
import SelectUser from "@/components/select-user";
export default {
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
    SelectTree,
    UploadFileList,
    SeparateInput,
    InvoiceEdit,
    SelectUser,
  },
  /** 定义属性 */
  data () {
    return {
      typeName: "",
      form: {},
      WarehouseOutStockOptions: WarehouseOutStockOptions,
      ProductionPlaceOptions: ProductionPlaceOptions,
      WhetherOptions: WhetherOptions,
      ManufacturerCertificateOptions: ManufacturerCertificateOptions,
      rules: {
        name: [
          { required: true, message: "资产名称不能为空", trigger: "blur" },
        ],
        unitName: [
          { required: true, message: "资产单位不能为空", trigger: "blur" },
        ],
        productionPlace: [
          { required: true, message: "产地类型不能为空", trigger: "blur" },
        ],
        assetSource: [
          { required: true, message: "产品来源不能为空", trigger: "blur" },
        ],
        price: [{ required: true, message: "单价不能为空", trigger: "blur" }],
        isBenefit: [
          { required: true, message: "是否效益资产不能为空", trigger: "blur" },
        ],
        passWord: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
      },
      certificateRules: {
        no: [
          {
            validator: this.certificateNoValidate,
            tigger: "blur",
          },
        ],
        certificateName: [
          {
            validator: this.certificateNameValidate,
            tigger: "blur",
          },
        ],
        startDate: [
          {
            validator: this.certificateStartDateValidate,
            tigger: "blur",
          },
        ],
        endDate: [
          {
            validator: this.certificateEndDateValidate,
            tigger: "blur",
          },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectNoneAsset,
      showAddDetails: true,
      showAddCapitalSource: true,
      Arabia_To_SimplifiedChinese: Arabia_To_SimplifiedChinese,
      defaultProps: {
        children: "children",
        label: "name",
      },
      showSelectUser: false,
    };
  },
  /** 计算属性，会监听依赖属性值随之变化 */
  computed: {},
  /** 监控data中的数据变化 */
  watch: {},
  /** 方法集合 */
  methods: {
    async InitData () {
      var query = this.$route.query;
      if (query.id) {
        this.handleUpdate(query.id);
      } else {
        this.handleAdd();
      }

      this.getBrands("");
      this.getManufacturers("");
      this.getSuppliers("");
      this.getRegistCerts("");
      this.getFinanceTypes("");
      this.getAssetTrees();
      this.getUnits("");
      this.getContracts();
      this.getProductSource();
      this.getCapitalSources();
      await this.GetNoneCertCategorys();
      if (this.STATIC_NoneCertCategorys.length > 0) {
        this.form.details[0].category = this.STATIC_NoneCertCategorys[0].id;
      }
    },
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetNoneAssetById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        if (!this.form.details) {
          this.form.details = [];
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
          if (!e.fileInfos || e.fileInfos.length == 0) {
            e.fileInfos = null;
          }
        });
        if (!this.form.capitalSourceDetails) {
          this.form.capitalSourceDetails = [];
        }
        this.form.capitalSourceDetails.forEach((e, index) => {
          e.$index = index + 1;
        });
        if (!this.form.fileInfos || this.form.fileInfos.length == 0) {
          this.form.fileInfos = [];
        }
        this.initWorkFlowProperty(this.form);
      });
    },
    /**
     * 初始化表单
     */
    resetForm () {
      this.form = {
        category: "0",
        no: null,
        name: "",
        specName: "",
        unitId: "",
        unitName: "",
        brandId: "",
        brandName: "",
        manufacturerId: "",
        manufacturerName: "",
        supplierId: "",
        supplierName: "",
        productionPlace: "",
        certId: "",
        certNo: "",
        assetTypeId: "",
        assetType: "",
        assetTypeName: "",
        financeTypeId: "",
        financeType: "",
        contractId: "",
        contractNo: "",
        productSourceId: "",
        productSourceName: "",
        price: "",
        isBenefit: "",
        createdTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        updateTime: this.parseTime(new Date(), "{y}-{m}-{d}"),
        capitalSourceDetails: [
          { capitalSourceId: "", capitalSourceName: "", ratio: 0, amount: 0 },
        ],
        remark: "",
        fileInfos: [],
        details: [
          {
            categoryName: "",
            fileInfos: null,
            stateName: "",
            no: "",
            category: null,
            certificateName: "",
            startDate: "",
            endDate: "",
            files: "",
            remark: "",
            $index: 1,
          },
        ],
        passWordState: 0,
        passWord: "",
        state: 1,
        orgCode :sessionStorage.getItem('orgId')
      };
    },
    // 保存
    submit () {
      if (this.isBeforeToday()) {
        this.$my_confirm("证件失效日期小于等于当前日期，是否仍要保存？", {
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "info",
        })
          .then(() => {
            // 继续创建
            this.save();
          })
          .catch(() => {
            return;
          });
      } else {
        this.save();
      }
    },
    save () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$my_message(
            `抱歉！当前页面尚有信息未填写完整，请补充后再次提交。`,
            "warning"
          );
          return false;
        }
        SaveNoneAsset(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    /**
     * 原库房选择
     */
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
    },
    /**
     * 调回库房选择
     */
    backWarehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.backWarehouseId = item.id;
        this.form.backWarehouseManagerId = item.managerId;
        this.form.backWarehouseManagerName = item.managerName;
      }
    },

    addDetail () {
      if (!this.form.details) {
        this.$set(this.form, "details", []);
      }
      if (this.form.details.length <= 5) {
        this.form.details.push({
          $index: this.form.details.length + 1,
          id: 0,
          categoryName: "",
          fileInfos: null,
          stateName: "",
          no: "",
          category: 1,
          certificateName: "",
          startDate: "",
          endDate: "",
          files: "",
          remark: "",
        });
        this.showAddDetails = true;
        if (this.form.details.length == 5) this.showAddDetails = false;
      } else {
        this.showAddDetails = false;
      }
    },
    removeDetail (item) {
      this.form.details = this.form.details.filter(
        (i) => item.$index != i.$index
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    addCapitalSource () {
      if (!this.form.capitalSourceDetails) {
        this.$set(this.form, "capitalSourceDetails", []);
      }
      if (this.form.capitalSourceDetails.length <= 5) {
        this.form.capitalSourceDetails.push({
          $index: this.form.capitalSourceDetails.length + 1,
          ratio: 0,
          amount: 0,
        });
        this.showAddCapitalSource = true;
        if (this.form.capitalSourceDetails.length == 5)
          this.showAddCapitalSource = false;
      } else {
        this.showAddCapitalSource = false;
      }
    },
    fileChange (e) {
      this.form.fileInfos = e;
    },
    removeCapitalSource (item) {
      this.form.capitalSourceDetails = this.form.capitalSourceDetails.filter(
        (i) => item.$index != i.$index
      );
      this.form.capitalSourceDetails.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    /**
     * 明细表添加
     */
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.resetDetailFormData();
    },
    /**
     * 单位选择
     */
    unitChange (val) {
      this.form.unitId = val;
    },
    /**
     * 品牌选择
     */
    brandChange (val) {
      this.form.brandId = val;
    },
    /**
     * 生产厂家选择
     */
    manufacturerChange (val) {
      this.form.manufacturerId = val;
      this.getRegistCerts();
    },
    /**
     * 供应商选择
     */
    supplierChange (val) {
      this.form.supplierId = val;
    },
    /**
     * 注册证号选择
     */
    certChange (val) {
      this.form.certId = val;
    },
    /**
     * 资产类型选择
     */
    handleCheckChange (node) {
      if (node) {
        this.form.assetTypeId = node.id;
        this.form.assetTypeName = node.name;
      } else {
        this.form.assetTypeId = "";
        this.form.assetTypeName = "";
      }
    },
    /**
     * 财务分类选择
     */

    financeTypeChange (node) {
      // this.form.financeTypeId = val;
      if (node) {
        this.form.financeTypeId = node.id;
        this.form.financeTypeName = node.name;
      } else {
        this.form.financeTypeId = "";
        this.form.financeTypeName = "";
      }
    },
    /**
     * 关联合同选择
     */
    contractChange (val) {
      this.form.contractId = val;
      // this.getFixedAssetList();
    },
    /**
     * 产品来源选择
     */
    productSourceChange (val) {
      this.form.productSourceId = val;
    },
    /**
     * 比例计算金额
     */
    ratioChange (item, left, right) {
      item.left = left;
      item.right = right;
      // if (left > 100) {
      //   left = 100;
      // }
      // if (left < 0) {
      //   left = 0;
      // }
      // let changeRatio = true; // 改变的是否为比例
      // if (left == item.ratio) {
      //   changeRatio = false;
      // }
      // item.ratio = left;
      // item.amount = right;

      // if (changeRatio) {
      //   item.amount = ((this.form.price * left) / 100).toFixed(2) * 1;
      // } else {
      //   item.ratio = ((right / this.form.price) * 100).toFixed(2) * 1;
      //   if (item.ratio > 100) {
      //     item.ratio = 100;
      //     item.amount = ((this.form.price * 100) / 100).toFixed(2) * 1;
      //   }
      // }
    },
    /**
     * 资金来源选择
     */
    csChange (item) {
      item.capitalSourceId = item.capitalSourceName;
      let obj = this.STATIC_CapitalSources.find(
        (e) => e.id == item.capitalSourceId
      );
      if (obj) {
        item.capitalSourceName = obj.name;
      }
    },
    /**
     * 结束时间选择
     */
    changeEndDate (item) {
      item.endDate = "2099-12-31";
    },
    /**
     * 时间选择
     */
    dateChange (item, index) {
      if (
        index == 0 &&
        item.endDate &&
        new Date(item.startDate).setHours(0, 0, 0, 0) >=
        new Date(item.endDate).setHours(0, 0, 0, 0)
      ) {
        // 开始时间修改，而且修改的时间大于结束时间时
        item.endDate = null;
      }
      if (item.startDate && item.endDate) {
        if (
          new Date(item.startDate).setHours(0, 0, 0, 0) <
          new Date().setHours(0, 0, 0, 0) &&
          new Date(item.endDate).setHours(0, 0, 0, 0) >=
          new Date().setHours(0, 0, 0, 0)
        ) {
          item.stateName = "效期内";
        } else {
          item.stateName = "效期外";
        }
      }
    },
    /**
     * 证书图片
     */
    detailsFileChange (e, item) {
      item.fileInfos = e;
    },
    /**
     * 论证人员选择
     */
    showSelectUserDialog () {
      this.showSelectUser = true;
    },
    /**
     * 获取论证人员
     */
    getSelectUserData (datas) {
      // let ids = data ? data.map(e => e.id) : []
      this.form.userInfos = datas;
      this.form.userIds = this.form.userInfos
        ? this.form.userInfos.map((i) => i.id).join(";")
        : "";
    },
    /**
     * 关闭论证人员选择
     */
    closeSelectUser () {
      this.showSelectUser = false;
    },
    /**
     * 移除人员
     */
    removeUserItem (item, e) {
      var userInfos = this.form.userInfos.filter((i) => i.id != item.id);
      var userIds = userInfos ? userInfos.map((i) => i.id).join(";") : "";
      this.$delete(this.form, "userInfos");
      this.$delete(this.form, "userIds");
      this.$set(this.form, "userInfos", userInfos);
      this.$set(this.form, "userIds", userIds);
      e.stopPropagation();
    },
    getRegistCerts (val) {
      this.getProductRegistCertsByManufacturer(
        this.form.manufacturerId,
        val,
        false
      );
    },
    // validate
    certificateNoValidate (rule, value, callback) {
      var item = this.form.details[rule.field.split(".")[1]];
      if (item.category && (!value || value == "")) {
        callback(new Error(`请填写证件编码`));
      } else {
        callback();
      }
    },
    certificateNameValidate (rule, value, callback) {
      var item = this.form.details[rule.field.split(".")[1]];
      if (item.category && (!value || value == "")) {
        callback(new Error(`请填写证件名称`));
      } else {
        callback();
      }
    },
    certificateStartDateValidate (rule, value, callback) {
      var item = this.form.details[rule.field.split(".")[1]];
      if (item.category && (!value || value == "")) {
        callback(new Error(`请填写证件生效日期`));
      } else {
        callback();
      }
    },
    certificateEndDateValidate (rule, value, callback) {
      var item = this.form.details[rule.field.split(".")[1]];
      if (item.category && (!value || value == "")) {
        callback(new Error(`请填写证件失效日期`));
      } else {
        callback();
      }
    },
    disabledDateFun (v, item) {
      return v.getTime() <= new Date(item.startDate).getTime();
    },
    isBeforeToday () {
      for (let i = 0; i < this.form.details.length; i++) {
        const element = this.form.details[i];
        if (element.endDate) {
          if (new Date(element.endDate).getTime() <= new Date().getTime()) {
            return true;
          }
        }
      }
    },
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.InitData();
  },
  /** 生命周期 - 挂载完成（可以访问DOM元素） */
  mounted () {
    this.getWarehouses();
  },
  /** 生命周期 - 创建之前 */
  beforeCreate () { },
  /** 生命周期 - 挂载之前 */
  beforeMount () { },
  /** 生命周期 - 更新之前 */
  beforeUpdate () { },
  /** 生命周期 - 更新之后 */
  updated () { },
  /** 生命周期 - 销毁之前 */
  beforeDestroy () { },
  /** 生命周期 - 销毁完成 */
  destroyed () { },
  /** 如果页面有keep-alive缓存功能，这个函数会触发 */
  activated () { },
};
</script>

<style lang="scss" scoped>
.certificateState {
  margin-left: 20px;
  font-size: 14px;
}
.psw-desc {
  line-height: 36px;
  font-size: 13px;
  color: #c8c9cc;
}
</style>
